import request from './request'
import type {
  UserHomeItem,
  UserListItem,
  UserOrderStatItem,
  UserOrderStats,
  UserUpcomingService,
} from './userslist'

export interface UserLinkedAccount {
  linked?: number | boolean
  email?: string
  display?: string
}

export interface UserDetail {
  id: number
  user_no?: string
  user_id?: string
  home_id?: string
  name?: string
  phone_code?: string
  phone?: string
  mobile?: string
  registered_mobile?: string
  address?: string
  email?: string
  google_account?: string | UserLinkedAccount
  google_email?: string
  apple_account?: string | UserLinkedAccount
  apple_email?: string
  apple_id?: string
  /** 无 homes 时可能落在顶层的房屋属性 */
  type?: string
  home_type?: string
  year_built?: string | number
  bedrooms?: string | number
  bathrooms?: string | number
  size?: string
  plan_label?: string
  care_plan?: string
  care_plan_label?: string
  subscription_text?: string
  is_subscribed?: boolean | number
  status?: number
  status_text?: string
  order_stats?: UserOrderStats
  order_stat_items?: UserOrderStatItem[]
  hmc_orders?: number
  fu_orders?: number
  ad_orders?: number
  no_orders_text?: string
  upcoming_service?: UserUpcomingService | string | null
  upcoming_plan_label?: string
  upcoming_display?: string
  upcoming_none_text?: string
  homes?: UserHomeItem[]
  create_time?: string
  update_time?: string
}

interface DetailResponse {
  code: number
  msg: string
  data: UserDetail
}

export async function getUserDetail(id: string | number): Promise<DetailResponse> {
  return request.post('/api/admin/user/detail', { id }) as Promise<DetailResponse>
}

/** 将详情字段收敛成列表项形状，便于刷新单行 */
export function userDetailToListItem(detail: UserDetail): UserListItem {
  return {
    id: detail.id,
    user_no: detail.user_no,
    user_id: detail.user_id,
    home_id: detail.home_id,
    name: detail.name,
    phone_code: detail.phone_code,
    phone: detail.phone,
    mobile: detail.mobile,
    registered_mobile: detail.registered_mobile,
    address: detail.address,
    email: detail.email,
    plan_label: detail.plan_label,
    care_plan: detail.care_plan,
    care_plan_label: detail.care_plan_label,
    subscription_text: detail.subscription_text,
    is_subscribed: detail.is_subscribed,
    status: detail.status,
    status_text: detail.status_text,
    order_stats: detail.order_stats,
    order_stat_items: detail.order_stat_items,
    no_orders_text: detail.no_orders_text,
    upcoming_service: detail.upcoming_service,
    upcoming_plan_label: detail.upcoming_plan_label,
    upcoming_display: detail.upcoming_display,
    upcoming_none_text: detail.upcoming_none_text,
    homes: detail.homes,
    create_time: detail.create_time,
    update_time: detail.update_time,
  }
}
